import { bindActionCreators } from 'redux';
import * as CartActions from '../actions/cart';
import * as EditorialHomeworkActions from '../actions/EditorialHomeworkActions';
import * as EditorialHomeworkDetailActions from '../actions/EditorialHomeworkDetailActions';
import * as ExerciseActions from '../actions/exercise';
import * as FavouriteEditorialHomeworkActions from '../actions/FavouriteEditorialHomeworkActions';
import * as FavouriteExercisesActions from '../actions/FavouriteExercisesActions';
import * as FavouriteHomeworkActions from '../actions/FavouriteHomeworkActions';
import * as HomeworkActions from '../actions/HomeworkActions';
import * as HomeworkDetailActions from '../actions/HomeworkDetailActions';
import * as HomeworkExportActions from '../actions/HomeworkExportActions';
import * as InvalsiActions from '../actions/InvalsiActions';
import * as MenuActions from '../actions/MenuActions';
import * as SearchFormActions from '../actions/SearchFormActions';
import * as RelatedExercisesActions from '../actions/RelatedExercisesActions';
import * as SpecialActions from '../actions/SpecialActions';
import * as SupportRequestActions from '../actions/SupportRequestActions';
import * as TickerActions from '../actions/TickerActions';
import * as UserNotificationActions from '../actions/UserNotificationActions';

export default function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            {
                ...CartActions,
                ...EditorialHomeworkActions,
                ...EditorialHomeworkDetailActions,
                ...ExerciseActions,
                ...FavouriteEditorialHomeworkActions,
                ...FavouriteExercisesActions,
                ...FavouriteHomeworkActions,
                ...HomeworkActions,
                ...HomeworkDetailActions,
                ...HomeworkExportActions,
                ...InvalsiActions,
                ...MenuActions,
                ...SearchFormActions,
                ...RelatedExercisesActions,
                ...SpecialActions,
                ...SupportRequestActions,
                ...TickerActions,
                ...UserNotificationActions
            },
            dispatch
        ),
        dispatch
    };
}
